/* unplugin-vue-components disabled */import script from "./netplatformConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./netplatformConfig.vue?vue&type=script&setup=true&lang=js"

import "./netplatformConfig.vue?vue&type=style&index=0&id=d3649466&lang=scss"

const __exports__ = script;

export default __exports__